import { useState } from "react";
import { Camera, Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { LOCAL_PHOTOS } from "@/lib/config";

export const LocalGallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="local" className="py-16 sm:py-24 bg-slate-50" data-testid="local-gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mb-8 sm:mb-12">
          <span className="inline-flex items-center gap-2 text-cyan-600 font-medium mb-4">
            <Camera className="h-5 w-5" /> Nuestro local
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900">Así es Lavandería Ozono por dentro</h2>
          <p className="mt-3 text-slate-600">
            Un espacio limpio, luminoso y nuevo en el Actur: máquinas industriales, central de pago,
            mesa para doblar y rincón de café. Pasa a conocernos.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 md:grid-rows-2 gap-3 sm:gap-4" data-testid="local-gallery-grid">
          {LOCAL_PHOTOS.map((p, i) => (
            <button
              key={p.src}
              type="button"
              onClick={() => setActive(p)}
              data-testid={`gallery-photo-${i}`}
              className={`group relative overflow-hidden rounded-2xl bg-slate-200 text-left focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 ${
                p.wide ? "col-span-2 md:row-span-2 aspect-[4/3] md:aspect-auto"
                  : p.wideRow ? "col-span-2 aspect-[2/1]" : "aspect-[4/3] md:aspect-auto"}`}
            >
              <img src={p.src} alt={p.alt} loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <span className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/10 to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
              <span className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-3">
                <span className="text-white text-sm font-medium drop-shadow">{p.caption}</span>
                <Maximize2 className="h-4 w-4 text-white/80 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
              </span>
            </button>
          ))}
        </div>
      </div>
      <Dialog open={Boolean(active)} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden bg-slate-950 border-slate-800" data-testid="gallery-lightbox">
          {active && (
            <>
              <DialogTitle className="sr-only">{active.caption}</DialogTitle>
              <img src={active.src} alt={active.alt} className="w-full max-h-[80vh] object-contain" />
              <p className="px-5 py-3 text-sm text-slate-300" data-testid="gallery-lightbox-caption">{active.caption}</p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
